import { createAction } from '@reduxjs/toolkit';

import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

// Login
export const postResetPasswordRequest = createAction('postResetPasswordRequest');
export const postResetPasswordSuccess = createAction('postResetPasswordSuccess');
export const postResetPasswordFailure = createAction<string>('postResetPasswordFailure');

export const postResetPassword = (postBody: RequestModel) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(postResetPasswordRequest());

    try {
        await api.post('admin/auth/reset-password', postBody);
        dispatch(postResetPasswordSuccess());
    } catch (e) {
        handleApiErrors(dispatch, postResetPasswordFailure, e);
    }
};

interface RequestModel {
    password: string;
    code: string;
}
